import { __assign, __awaiter, __generator, __read, __spread } from "tslib";
import { get } from 'lodash';
import React from 'react';
import { app as api } from '@ekuaibao/whispered';
import { getNumberColor } from '@ekuaibao/lib/lib/entityUtil/entityTableUtil';
import { parseQuery2Select } from '@ekuaibao/lib/lib/parseQuery2Select';
import { fixBaseData, fixMoney, fixPayeeInfo, fixSwitch, SwitcherData, parseColumnFilter } from '../data-grid/columnOthers';
import fetchFixer from '../data-grid/fetchFixer';
import PersonnelList from '../puppet/personnelList/PersonnelList';
import { Icon } from 'antd';
import { Tooltip } from '@hose/eui';
import { fnShouldShowWarning } from '../../components/utils/fnFormartDatalinkData';
import DataLinkUrlText from './DataLinkUrlText';
import DataLinkCode from './DataLinkCode';
import { getDisplayName, getStaffShowByConfig } from "../utilFn";
import { fixEntityObj } from '../../lib/utils';
import { isString } from '@ekuaibao/helpers';
import { T } from '@ekuaibao/i18n';
import StaffFilter from '../data-grid/StaffFilter';
import moment from 'moment';
export function parseColumns(param) {
    var bus = param.bus, action = param.action, fields = param.fields, otherColumns = param.otherColumns, path = param.path, useCountCanLink = param.useCountCanLink, platformType = param.platformType, entityInfoMap = param.entityInfoMap, entityInfo = param.entityInfo, linkType = param.linkType, from = param.from, useNewStyle = param.useNewStyle, moneyTextAlign = param.moneyTextAlign;
    var newFields = [];
    var fieldMap = {};
    if (fields && path) {
        fieldMap = parseFieldMap(fields, path);
    }
    fields.forEach(function (f) {
        if (!(f.type === 'list' && platformType === 'PRIVATE_CAR')) {
            newFields.push(f);
        }
    });
    if (platformType === 'TRAVEL_MANAGEMENT') {
        var activeField = {
            name: "active",
            label: "可用状态",
            type: "switcher",
            source: "dataLink",
            optional: false,
            defaultValue: null,
            formula: false,
            index: false,
            systemField: false,
            childrenOptional: {},
            calculation: {
                dependencies: [],
                dependenciesBy: [],
                order: -1
            }
        };
        var idx = fields.findIndex(function (i) { return i.label === '订购状态'; });
        fields.splice(idx, 0, activeField);
    }
    var columns = parseToColumn({
        fields: fields,
        fixedCount: 0,
        otherColumns: otherColumns || undefined,
        action: action ? action : undefined,
        bus: bus,
        entityInfoMap: entityInfoMap,
        useCountCanLink: useCountCanLink,
        platformType: platformType,
        entityInfo: entityInfo,
        linkType: linkType,
        from: from,
        useNewStyle: useNewStyle,
        moneyTextAlign: moneyTextAlign
    });
    return { columns: columns, fieldMap: fieldMap };
}
export function parseFieldMap(fields, path) {
    var fieldMap = {};
    fields.forEach(function (f) {
        if (f.name === 'entityId') {
            fieldMap[f.name] = __assign(__assign({}, f), { dataType: { type: f.type } });
        }
        else {
            fieldMap["" + path[f.name]] = __assign(__assign({}, f), { dataType: { type: f.type } });
        }
    });
    return fieldMap;
}
function parseToColumn(_a) {
    var fields = _a.fields, fixedCount = _a.fixedCount, otherColumns = _a.otherColumns, action = _a.action, bus = _a.bus, useCountCanLink = _a.useCountCanLink, platformType = _a.platformType, entityInfoMap = _a.entityInfoMap, entityInfo = _a.entityInfo, linkType = _a.linkType, from = _a.from, useNewStyle = _a.useNewStyle, moneyTextAlign = _a.moneyTextAlign;
    var columns = createColumns({
        fields: fields,
        fixedCount: fixedCount,
        bus: bus,
        useCountCanLink: useCountCanLink,
        platformType: platformType,
        entityInfoMap: entityInfoMap,
        entityInfo: entityInfo,
        linkType: linkType,
        from: from,
        useNewStyle: useNewStyle,
        moneyTextAlign: moneyTextAlign
    });
    if (otherColumns) {
        columns.push(otherColumns(bus, columns.length));
    }
    if (action) {
        columns.push(action(bus, columns.length));
    }
    return columns;
}
export function createColumns(_a) {
    var fields = _a.fields, fixedCount = _a.fixedCount, bus = _a.bus, useCountCanLink = _a.useCountCanLink, platformType = _a.platformType, entityInfoMap = _a.entityInfoMap, entityInfo = _a.entityInfo, linkType = _a.linkType, from = _a.from, useNewStyle = _a.useNewStyle, moneyTextAlign = _a.moneyTextAlign;
    return fields.map(function (line, index, arr) {
        return parseColumn({
            property: line,
            index: index,
            fixedCount: fixedCount,
            bus: bus,
            length: arr.length,
            isSingleSelect: false,
            useCountCanLink: useCountCanLink,
            platformType: platformType,
            entityInfoMap: entityInfoMap,
            entityInfo: entityInfo,
            linkType: linkType,
            from: from,
            useNewStyle: useNewStyle,
            moneyTextAlign: moneyTextAlign
        });
    });
}
export function parseData(dataSource) {
    return dataSource.map(function (line) {
        return __assign(__assign({}, line), { key: line.id, id: line.id, platformId: line.platformId, active: line.active, dataLinkCount: { useCount: line.useCount, totalCount: line.totalCount } });
    });
}
var hanldeOnClick = function (e, value, entityInfo) {
    e && e.stopPropagation && e.stopPropagation();
    e && e.preventDefault && e.preventDefault();
    if (value) {
        var type = get(value, 'data.dataLink.entity.type', '');
        if (type === 'CORPORATEBANKING_CONTRAT') {
            var data = get(value, 'data', {});
            api.open('@business-to-business:ContractDetailDrawer', { data: data });
        }
        else {
            var id = get(value, 'data.dataLink.id');
            api.open('@bills:DataLinkDetailModal', {
                entityInfo: { dataLink: { id: id } },
                showClose: true,
                viewKey: 'DataLinkDetailModal'
            });
        }
    }
};
function parseColumn(_a) {
    var property = _a.property, index = _a.index, fixedCount = _a.fixedCount, bus = _a.bus, isSingleSelect = _a.isSingleSelect, useCountCanLink = _a.useCountCanLink, length = _a.length, platformType = _a.platformType, entityInfoMap = _a.entityInfoMap, entityInfo = _a.entityInfo, linkType = _a.linkType, from = _a.from, useNewStyle = _a.useNewStyle, moneyTextAlign = _a.moneyTextAlign;
    var label = property.label, enLabel = property.enLabel, type = property.type, fixed = property.fixed, entity = property.entity;
    var dataIndex = parseDataIndex(property);
    var filterOptions = parseColumnFilter({ dataType: { entity: entity, type: type } });
    var others = parseMeta2ColumnOthers({
        type: type,
        property: property,
        bus: bus,
        isSingleSelect: isSingleSelect,
        useCountCanLink: useCountCanLink,
        platformType: platformType,
        entityInfoMap: entityInfoMap,
        entityInfo: entityInfo,
        linkType: linkType,
        from: from,
        useNewStyle: useNewStyle,
        moneyTextAlign: moneyTextAlign
    });
    var mfixed = length <= 4 ? false : index < fixedCount;
    var width = length <= 4 ? {} : { width: 200 };
    var EXCLUDE_I18N = ['code'];
    var realLabel = (i18n.currentLocale === 'en-US' && enLabel) ? enLabel : label;
    var showLabel = EXCLUDE_I18N.includes(realLabel) ? realLabel : i18n.get(realLabel);
    return __assign(__assign(__assign(__assign({ title: showLabel || label, dataIndex: dataIndex, dataType: type, filterType: (entity === null || entity === void 0 ? void 0 : entity.startsWith('basedata.Enum')) ? false : type, key: dataIndex, sorter: true, label: showLabel || label, value: dataIndex, property: property }, width), { className: 'fs-14', fixed: !!fixed ? fixed : mfixed }), others), filterOptions);
}
function parseDataIndex(property) {
    var _a = property.source, source = _a === void 0 ? 'form' : _a, name = property.name;
    if (source === 'planned') {
        var array = name.split('_');
        var suffix = array[array.length - 1].toUpperCase();
        return source + "." + name + "." + suffix;
    }
    return source + "." + name;
}
export function parseMeta2ColumnOthers(_a) {
    var type = _a.type, property = _a.property, bus = _a.bus, isSingleSelect = _a.isSingleSelect, useCountCanLink = _a.useCountCanLink, platformType = _a.platformType, entityInfoMap = _a.entityInfoMap, entityInfo = _a.entityInfo, linkType = _a.linkType, from = _a.from, _b = _a.moneyTextAlign, moneyTextAlign = _b === void 0 ? 'right' : _b, useNewStyle = _a.useNewStyle;
    if (type === 'text' && property.name.endsWith('原始单据')) {
        return fixBill();
    }
    if (type === 'ref' && (property === null || property === void 0 ? void 0 : property.entity) === 'basedata.Enum.currency') {
        return fixCurrency(property.name);
    }
    if (type === 'text') {
        return fixText(__assign(__assign({}, property), { from: from, entityInfo: entityInfo, useNewStyle: useNewStyle }));
    }
    if (type === 'money') {
        return fixMoney({ valueSize: 14, canFilter: property.source !== 'planned', moneyTextAlign: moneyTextAlign });
    }
    if (type === 'active' || property.name === 'active') {
        return fixActive(property, isSingleSelect, platformType);
    }
    if (type === 'switcher') {
        return fixSwitch(SwitcherData);
    }
    if (type === 'dataLinkCount' || property.name === 'useCount') {
        return fixDataLinkCount(property, bus, isSingleSelect, useCountCanLink);
    }
    if (type === 'location') {
        return fixLocation();
    }
    if (type === 'duration') {
        return fixDuration();
    }
    if (type === 'staffFZ' || type === 'staffCYR') {
        return fixStaff(type, bus, property, platformType);
    }
    if (type === 'list' && get(property, 'elemType.entity', '').startsWith('datalink.DataLinkEntity')) {
        return fixDataLinks(entityInfo);
    }
    if (type === 'list' && property.elemType && property.elemType.entity === 'pay.PayeeInfo') {
        return fixMutilPayeeInfo(bus, platformType);
    }
    if (type === 'list') {
        return fixList(property);
    }
    if (type === 'number') {
        return fixNumber(property);
    }
    if (type === 'dataLinkType') {
        return fixDataLinkType(entityInfoMap, from);
    }
    if (type === 'settlementOpportunity') {
        return fixSettlementOpportunity();
    }
    if (type === 'settlementPeriod') {
        return fixSettlementPeriod();
    }
    if (type === 'date') {
        return fixDate(property);
    }
    if (type === 'dateRange') {
        return fixDateRange(property);
    }
    if (type === 'ref') {
        if (property.entity.startsWith('pay.PayeeInfo')) {
            return fixPayeeInfo();
        }
        else if (property.entity.startsWith('organization.Staff')) {
            return fixStaffName();
        }
        else if (property.entity.startsWith('datalink.DataLinkEntity')) {
            return fixDataLink(entityInfo);
        }
        else if (property.entity.startsWith('basedata.Dimension')) {
            return fixBaseData();
        }
        else if (property.entity.startsWith('basedata.city')) {
            return fixCity();
        }
        else {
            return fixRefOther();
        }
    }
    if (property.label === '单号' && linkType === 'CHANPAY') {
        return fixDocumentNo(property.label);
    }
    return {
        render: function (value) {
            return (React.createElement(Tooltip, { placement: "topLeft", title: value },
                React.createElement("span", null, value)));
        }
    };
}
var opportunityFn = api.invokeServiceAsLazyValue('@supplier-file:get:supplier:enums');
function fixSettlementOpportunity() {
    var opportunity = opportunityFn().opportunity;
    return {
        render: function (val) {
            var settleType = opportunity.find(function (el) { return el.name === val; });
            return settleType ? settleType.label : '-';
        },
        filterType: 'list',
        lookup: {
            dataSource: opportunity,
            displayExpr: 'label',
            valueExpr: 'name'
        }
    };
}
var periodFn = api.invokeServiceAsLazyValue('@supplier-file:get:supplier:enums');
function fixSettlementPeriod() {
    var period = periodFn().period;
    return {
        render: function (val) {
            var settleTime = period.find(function (el) { return el.name === val; });
            return settleTime ? settleTime.label : '-';
        },
        filterType: 'list',
        lookup: {
            dataSource: period,
            displayExpr: 'label',
            valueExpr: 'name'
        }
    };
}
function fixMutilPayeeInfo(bus, platformType) {
    return {
        width: 350,
        render: function (payeeInfo, record) {
            if (!(Array.isArray(payeeInfo) && payeeInfo.length)) {
                return React.createElement(NullCell, null);
            }
            var item = payeeInfo[0];
            var name = item.name, bank = item.bank, branch = item.branch, cardNo = item.cardNo, icon = item.icon, type = item.type;
            var bankName = bank || branch;
            var accountType = type === 'PERSONAL' ? i18n.get('个人账户') : i18n.get('对公账户');
            var cardNoLable = " **** " + cardNo.substring(cardNo.length - 4, cardNo.length);
            return (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                React.createElement("div", { className: "bank-card", style: {
                        background: '#fff',
                        border: '1px solid rgba(29,43,61,0.09)',
                        borderRadius: '4px',
                        padding: '8px'
                    } },
                    React.createElement("div", { className: "bank-title", style: { display: 'flex', justifyContent: 'space-between', marginBottom: '8px' } },
                        React.createElement("div", { className: "text-nowrap-ellipsis", style: { fontWeight: 600, color: 'rgba(29,43,61,1)', width: '160px' } }, name),
                        React.createElement("div", { style: { fontSize: '12px', color: 'rgba(29,43,61,0.4)' } }, accountType)),
                    React.createElement("div", { className: "bank-body", style: { display: 'flex' } },
                        icon && React.createElement("img", { className: "bank-icon-img", src: icon, alt: "" }),
                        React.createElement("div", { className: "bank-name text-nowrap-ellipsis", style: { width: '150px' } }, bankName),
                        React.createElement("div", { className: "bank-cardNo" }, cardNoLable))),
                React.createElement("span", { className: "bank-more", style: { color: 'rgba(0,107,224,1)', cursor: 'pointer', padding: '8px 16px' }, onClick: function () {
                        return bus.emit('edit:table:supplier', platformType === 'SUPPLIER' ? record : get(record, 'dataLink'));
                    } }, i18n.get('更多'))));
        }
    };
}
export function fixDate(props) {
    return {
        render: function (value) {
            if (!value) {
                return React.createElement(NullCell, null);
            }
            var withTime = props === null || props === void 0 ? void 0 : props.withTime;
            var format = withTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
            value = moment(value).format(format);
            if (value === 'Invalid date') {
                value = '-';
            }
            return React.createElement("span", null, value);
        }
    };
}
export function fixDateRange(props) {
    return {
        render: function (value) {
            if (!value || (typeof value === 'string' && !value.length)) {
                return React.createElement(NullCell, null);
            }
            var start = 0;
            var end = 0;
            if (Array.isArray(value)) {
                start = value[0];
                end = value[1];
            }
            else if (typeof value === 'object') {
                start = value.start;
                end = value.end;
            }
            if (!start || !end) {
                return React.createElement(NullCell, null);
            }
            var withTime = props === null || props === void 0 ? void 0 : props.withTime;
            var format = withTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
            start = moment(start).format(format);
            end = moment(end).format(format);
            var text = start + " ~ " + end;
            return (React.createElement(Tooltip, { placement: "topLeft", title: text },
                React.createElement("span", null, text)));
        }
    };
}
function fixDataLinkType(entityInfoMap, from) {
    return {
        filterType: undefined,
        render: function (text, record) {
            if (!text) {
                return React.createElement("span", null, '-');
            }
            var value = entityInfoMap[text];
            if (from) {
                value = value || get(record, 'dataLink.entity.name');
            }
            return React.createElement("span", { style: {
                    wordBreak: 'break-all',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                } }, value ? value : '-');
        }
    };
}
function getTitleByTem(value) {
    var _a, _b;
    if (!value) {
        return { title: '-' };
    }
    var dataLink = (_b = (_a = value === null || value === void 0 ? void 0 : value.data) === null || _a === void 0 ? void 0 : _a.dataLink) !== null && _b !== void 0 ? _b : {};
    var title = '';
    var code = '';
    Object.keys(dataLink).forEach(function (key) {
        if (key.endsWith('_name')) {
            title = dataLink[key];
        }
        if (key.endsWith('_code')) {
            code = dataLink[key];
        }
    });
    return title === '-' || code === '-' || !title || !code ? { title: title || '-', code: '-' } : { title: title, code: code };
}
export function fixDataLink(entityInfo) {
    return {
        render: function (value) {
            var data = getTitleByTem(value);
            var title = data.title, code = data.code;
            return title === '-' || code === '-' ? (React.createElement("span", null, title)) : (React.createElement(Tooltip, { placement: "topLeft", title: code },
                React.createElement("span", { onClick: function (e) { return hanldeOnClick(e, value, entityInfo); }, style: {
                        wordBreak: 'break-all',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: 'var(--eui-primary-pri-500)',
                        cursor: 'pointer'
                    } }, title)));
        }
    };
}
export function fixDataLinks(entityInfo) {
    return {
        render: function (value) {
            if (value && Array.isArray(value)) {
                var titleList_1 = [];
                var maps = value.map(function (item, index) {
                    var data = getTitleByTem(item);
                    var title = data.title, code = data.code;
                    titleList_1.push(title);
                    return title === '-' || code === '-' ? (React.createElement("span", null, title)) : (React.createElement("a", { style: { marginRight: 8 }, onClick: function (e) { return hanldeOnClick(e, item, entityInfo); } }, title));
                });
                return React.createElement(Tooltip, { placement: "topLeft", title: titleList_1.join(',') },
                    React.createElement("div", { style: {
                            whiteSpace: 'normal',
                            wordBreak: 'break-all',
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        } }, maps));
            }
            else {
                return React.createElement(NullCell, null);
            }
        }
    };
}
export function fixCity() {
    return {
        render: function (text) {
            if (!text) {
                return React.createElement("span", null, '-');
            }
            var arr = JSON.parse(text);
            var label = arr.map(function (line) { return i18n.currentLocale === 'en-US' ? (line === null || line === void 0 ? void 0 : line.enLabel) || (line === null || line === void 0 ? void 0 : line.label) : line === null || line === void 0 ? void 0 : line.label; }).join(',');
            return (React.createElement(Tooltip, { placement: "topLeft", title: label },
                React.createElement("span", { style: {
                        wordBreak: 'break-all',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    } }, label)));
        }
    };
}
export function fixRefOther() {
    return {
        render: function (value) {
            if (!value) {
                return React.createElement(NullCell, null);
            }
            if (typeof value === 'object') {
                value = getDisplayName(value);
            }
            if (value) {
                return (React.createElement(Tooltip, { placement: "topLeft", title: value },
                    React.createElement("span", { style: {
                            wordBreak: 'break-all',
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        } }, value)));
            }
            return React.createElement(NullCell, null);
        }
    };
}
export function fixList(property) {
    var _a = property.elemType, type = _a.type, entity = _a.entity;
    if (type === 'ref' && entity === 'organization.Staff') {
        return {
            filterType: 'ref',
            render: function (value) {
                var _a;
                var staffs = (_a = value === null || value === void 0 ? void 0 : value.filter(function (i) { return i; })) === null || _a === void 0 ? void 0 : _a.map(function (item) { return getStaffShowByConfig(item); }).join(',');
                if (staffs) {
                    return (React.createElement(Tooltip, { placement: "topLeft", title: staffs },
                        React.createElement("span", { style: {
                                wordBreak: 'break-all',
                                display: '-webkit-box',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            } }, staffs)));
                }
                return React.createElement(NullCell, null);
            }
        };
    }
    else if (type === 'ref' && entity.startsWith('basedata.Dimension.')) {
        return {
            filterType: 'ref',
            render: function (value) {
                var _a, _b;
                var dimension = (_b = (_a = value === null || value === void 0 ? void 0 : value.filter(function (i) { return i; })) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.name + "(" + item.code + ")"; })) === null || _b === void 0 ? void 0 : _b.join(',');
                if (dimension) {
                    return (React.createElement(Tooltip, { placement: "topLeft", title: dimension },
                        React.createElement("span", { style: {
                                wordBreak: 'break-all',
                                display: '-webkit-box',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            } }, dimension)));
                }
                return React.createElement(NullCell, null);
            }
        };
    }
    else if (type === 'location') {
        return {
            render: function (value) {
                if (value && value.length) {
                    var text = value
                        .filter(function (i) { return i; })
                        .map(function (v) { return v.name ? v.name + "(" + v.address + ")" : v.address; })
                        .join('/');
                    return (React.createElement(Tooltip, { placement: "topLeft", title: text },
                        React.createElement("span", { style: {
                                wordBreak: 'break-all',
                                display: '-webkit-box',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            } }, text)));
                }
                return React.createElement(NullCell, null);
            }
        };
    }
    else {
        return {
            render: function (value) {
                return React.createElement("span", null, i18n.get('无法解析'));
            }
        };
    }
}
export function parseOptions(_a) {
    var _b;
    var options = _a.options, isSingleSelect = _a.isSingleSelect, _c = _a.entityInfo, entityInfo = _c === void 0 ? {} : _c, fieldMap = _a.fieldMap, dataLinkList = _a.dataLinkList, isRemuneration = _a.isRemuneration, flowId = _a.flowId, isSelectOwner = _a.isSelectOwner, _d = _a.type, type = _d === void 0 ? 'DATALINK' : _d, expenseCodeList = _a.expenseCodeList, otherParams = _a.otherParams, _e = _a.newFilter, newFilter = _e === void 0 ? true : _e, _f = _a.isIgnoreSearchTextUpperOrLower, isIgnoreSearchTextUpperOrLower = _f === void 0 ? false : _f;
    var param = Object.assign({}, options);
    param = fetchFixer(param, __assign(__assign({}, fieldMap), { 'form.dataLinkCount': { name: 'form.dataLinkCount' } }), newFilter);
    var _g = param.filters, filters = _g === void 0 ? {} : _g, orderManagement = param.orderManagement, formdataQuery = param.formdataQuery;
    var searchText = param.searchText;
    if (isSingleSelect && param.filters && !param.filters.active) {
        filters = __assign(__assign({}, filters), { active: true });
    }
    param.filters = filters;
    var _h = entityInfo, fields = _h.fields, entityInfoType = _h.type;
    var columns = [];
    if (searchText && searchText.length) {
        if (isIgnoreSearchTextUpperOrLower) {
            columns = ['name', 'code'];
        }
        else {
            if (isRemuneration) {
                columns = fields === null || fields === void 0 ? void 0 : fields.filter(function (f) { var _a, _b; return ((_a = f === null || f === void 0 ? void 0 : f.name) === null || _a === void 0 ? void 0 : _a.indexOf('_name')) > -1 || ((_b = f === null || f === void 0 ? void 0 : f.name) === null || _b === void 0 ? void 0 : _b.indexOf('_工号证件号')) > -1; });
            }
            else {
                columns = fields === null || fields === void 0 ? void 0 : fields.slice().filter(function (f) { var _a, _b; return ((_a = f === null || f === void 0 ? void 0 : f.name) === null || _a === void 0 ? void 0 : _a.indexOf('_name')) > -1 || ((_b = f === null || f === void 0 ? void 0 : f.name) === null || _b === void 0 ? void 0 : _b.indexOf('_code')) > -1 || (f === null || f === void 0 ? void 0 : f.name) === 'name'; });
            }
            columns = columns === null || columns === void 0 ? void 0 : columns.map(function (f) { return "form." + (f === null || f === void 0 ? void 0 : f.name); });
        }
    }
    var query = parseQuery2Select(param, undefined, columns, dataLinkList, flowId, fieldMap);
    if (type === 'PRIVATE_CAR' || type === 'TRAVEL_MANAGEMENT') {
        query.orderBy('createTime', 'DESC');
    }
    if (orderManagement) {
        formdataQuery && constructorOrderManageQuery(query, formdataQuery);
    }
    if (entityInfoType === 'ORDER' && type === 'TRAVEL_MANAGEMENT') {
        var entityId_1 = entityInfo.id;
        var filterCode = expenseCodeList && expenseCodeList.length
            ?
                expenseCodeList.map(function (item) { return "form.E_" + entityId_1 + "_\u7533\u8BF7\u5355\u7F16\u53F7.containsIgnoreCase(\"" + item + "\")"; }).join(' || ')
            : '';
        if (filterCode) {
            query.filterBy(filterCode);
        }
    }
    if (isSelectOwner) {
        query = query.select("ownerId(...),...");
    }
    if ((_b = otherParams === null || otherParams === void 0 ? void 0 : otherParams.filters) === null || _b === void 0 ? void 0 : _b.length) {
        if (Array.isArray(otherParams.filters)) {
            otherParams.filters.forEach(function (filter) {
                query.filterBy(filter);
            });
        }
        else if (isString(otherParams === null || otherParams === void 0 ? void 0 : otherParams.filters)) {
            query.filterBy(otherParams === null || otherParams === void 0 ? void 0 : otherParams.filters);
        }
    }
    query = query.value();
    return query;
}
var constructorOrderManageQuery = function (query, formdataQuery) {
    formdataQuery &&
        Object.keys(formdataQuery).forEach(function (e) {
            if (e && e != undefined) {
                query.filterBy(e + ".containsIgnoreCase(\"" + formdataQuery[e] + "\")");
            }
        });
};
var filterDataSource = [
    { label: React.createElement(T, { name: "\u5DF2\u542F\u7528" }), value: 'true' },
    { label: React.createElement(T, { name: "\u5DF2\u505C\u7528" }), value: 'false' }
];
var filterDataSourceT = [
    { label: React.createElement(T, { name: "\u53EF\u7528" }), value: 'true' },
    { label: React.createElement(T, { name: "\u4E0D\u53EF\u7528" }), value: 'false' }
];
var activeLookupT = {
    dataSource: filterDataSourceT,
    displayExpr: 'label',
    valueExpr: 'value'
};
var activeLookup = {
    dataSource: filterDataSource,
    displayExpr: 'label',
    valueExpr: 'value'
};
function fixActive(_property, isSingleSelect, platformType) {
    return {
        filterType: isSingleSelect ? undefined : 'list',
        filterDataSource: platformType === 'TRAVEL_MANAGEMENT' ? filterDataSourceT : filterDataSource,
        lookup: platformType === 'TRAVEL_MANAGEMENT' ? activeLookupT : activeLookup,
        render: function (active) {
            if (platformType === 'TRAVEL_MANAGEMENT') {
                return active ? i18n.get('可用') : i18n.get('不可用');
            }
            var backgroundColor = active ? 'var(--eui-function-info-500)' : 'var(--eui-decorative-neu-500)';
            var styles = { width: 6, height: 6, backgroundColor: backgroundColor, marginRight: 8, borderRadius: 4 };
            var text = active === undefined ? '-' : i18n.get('已停用');
            return active ? (React.createElement("div", { className: "option-line" },
                React.createElement("span", { style: styles }),
                i18n.get('启用中'))) : (React.createElement("div", { className: "option-line" },
                active === undefined ? null : React.createElement("span", { style: styles }),
                text));
        }
    };
}
function fixLocation() {
    return {
        filterType: undefined,
        render: function (location) {
            if (!location) {
                return '-';
            }
            var _a = location, name = _a.name, address = _a.address;
            return React.createElement("span", null, name ? name + "(" + address + ")" : address);
        }
    };
}
function fixBill() {
    return {
        filterType: undefined,
        render: function (bill) {
            var value = typeof bill === 'object' ? get(bill, 'form.title', '-') : bill ? bill : '-';
            return React.createElement("span", null, value);
        }
    };
}
export var formatLinkText = function (value, propertyName) {
    var linkObj;
    var shouldNotOpenLink = !!propertyName;
    if (shouldNotOpenLink) {
        var n = String(propertyName).split('_')[2];
        shouldNotOpenLink = ['name', 'code'].includes(n);
    }
    var needOpenLink = !shouldNotOpenLink && String(value).includes('"link"');
    if (needOpenLink) {
        try {
            linkObj = JSON.parse(value);
        }
        catch (e) {
        }
    }
    var fnOnClick = null;
    if (linkObj === null || linkObj === void 0 ? void 0 : linkObj.link) {
        fnOnClick = function () { return __awaiter(void 0, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, checkBaiwangPreviewUrl(linkObj.link)];
                    case 1:
                        url = _a.sent();
                        api.emit('@vendor:open:link', url);
                        return [2];
                }
            });
        }); };
    }
    var textValue = value ? (linkObj && linkObj.link ? (linkObj.name ? linkObj.name : linkObj.link) : value) : '-';
    var domValue = fnOnClick ? DataLinkUrlText(textValue, fnOnClick) : textValue;
    return { textValue: textValue, domValue: domValue, isRedirectText: !!fnOnClick };
};
export var checkBaiwangPreviewUrl = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var inGroup, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                inGroup = checkPlatformIsGroup();
                if (!(inGroup && url)) return [3, 2];
                return [4, api.invokeService('@bills:get:baiwang:previewUrl', url)];
            case 1:
                res = _a.sent();
                return [2, res === null || res === void 0 ? void 0 : res.value];
            case 2: return [2, url];
        }
    });
}); };
export var checkPlatformIsGroup = function () {
    var _a;
    var whiteList = ['Group-ekb', 'Group-mc', 'plugin', 'movie'];
    return whiteList.includes((_a = window.PLATFORMINFO) === null || _a === void 0 ? void 0 : _a.platform);
};
export var renderRedirectCode = function (propertyName, data, value) {
    var inGroup = checkPlatformIsGroup();
    if (!IS_STANDALONE && !inGroup) {
        return null;
    }
    var dataLink = data.dataLink, sourceId = data.sourceId;
    if (sourceId && propertyName === "E_" + dataLink.entityId + "_code") {
        return DataLinkCode(sourceId, value);
    }
    return null;
};
var renderEveryStatus = function (filterDataSourcePayStatus, from) {
    if (from === 'MyContract') {
        return { sorter: false, filterType: undefined };
    }
    return {
        filterType: 'list',
        filterDataSource: filterDataSourcePayStatus,
        lookup: {
            dataSource: filterDataSourcePayStatus,
            displayExpr: 'label',
            valueExpr: 'value'
        }
    };
};
var StatusColor;
(function (StatusColor) {
    StatusColor["#A4D76E"] = "#A4D76E";
    StatusColor["#CBCBCB"] = "#CBCBCB";
    StatusColor["rgba(34, 178, 204, 0.36)"] = "rgba(34, 178, 204, 0.36)";
    StatusColor["#22B2CC"] = "#22B2CC";
    StatusColor["#F4664A"] = "#F4664A";
    StatusColor["#FAAD14"] = "#FAAD14";
})(StatusColor || (StatusColor = {}));
var renderStatusStyle = function (value) {
    var backgroundColor;
    switch (value) {
        case '已付款':
        case '全部发起':
        case '全部支付':
            backgroundColor = StatusColor['#22B2CC'];
            break;
        case '部分付款':
        case '部分发起':
        case '部分支付':
            backgroundColor = StatusColor['rgba(34, 178, 204, 0.36)'];
            break;
        case '未付款':
        case '未发起':
        case '未支付':
            backgroundColor = StatusColor['#CBCBCB'];
            break;
        case '超额付款':
        case '超额发起':
        case '超额支付':
            backgroundColor = StatusColor['#F4664A'];
            break;
        default:
            break;
    }
    return { width: 6, height: 6, backgroundColor: backgroundColor, marginRight: 8, borderRadius: 4 };
};
function renderDataLinkTableTextStyleNew(lineNumber, useNewStyle) {
    if (lineNumber === void 0) { lineNumber = '3'; }
    var style = {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: !useNewStyle ? '-webkit-box' : 'block',
        '-webkitBoxOrient': 'vertical',
        '-webkitLineClamp': lineNumber
    };
    return style;
}
var contractStateMap = {
    DRAFT: i18n.get('草稿'),
    REJECTED: i18n.get('驳回'),
    APPROVING: i18n.get('审批中'),
    EXCUTING: i18n.get('执行中'),
    CLOSE: i18n.get('关闭'),
    END: i18n.get('已完成')
};
var settleStateMap = {
    DRAFT: i18n.get('待执行'),
    PAYING: i18n.get('执行中'),
    PAID: i18n.get('已支付')
};
function fixText(_a) {
    var name = _a.name, label = _a.label, from = _a.from, entityInfo = _a.entityInfo, useNewStyle = _a.useNewStyle;
    var nameArr = (name === null || name === void 0 ? void 0 : name.split('_')) || [];
    switch (nameArr[nameArr.length - 1]) {
        case '付款计划发起状态':
            return __assign({ render: function (value, record) {
                    var styles = renderStatusStyle(value);
                    return (React.createElement("div", { className: "option-line" },
                        React.createElement("span", { style: styles }),
                        value ? i18n.get(value) : '-'));
                } }, renderEveryStatus([
                { label: i18n.get('未发起'), value: i18n.get('未发起') },
                { label: i18n.get('部分发起'), value: i18n.get('部分发起') },
                { label: i18n.get('全部发起'), value: i18n.get('全部发起') },
                { label: i18n.get('超额发起'), value: i18n.get('超额发起') }
            ]));
        case 'contractState':
            return __assign({ render: function (value, record) {
                    return React.createElement("div", { className: "option-line" }, contractStateMap[value] || '-');
                } }, renderEveryStatus([
                { label: i18n.get('草稿'), value: 'DRAFT' },
                { label: i18n.get('驳回'), value: 'REJECTED' },
                { label: i18n.get('审批中'), value: 'APPROVING' },
                { label: i18n.get('执行中'), value: 'EXCUTING' },
                { label: i18n.get('关闭'), value: 'CLOSE' },
                { label: i18n.get('已完成'), value: 'END' }
            ], from));
        case 'settleState':
            return __assign({ render: function (value, record) {
                    return React.createElement("div", { className: "option-line" }, settleStateMap[value] || '-');
                } }, renderEveryStatus([
                { label: i18n.get('待执行'), value: 'DRAFT' },
                { label: i18n.get('执行中'), value: 'PAYING' },
                { label: i18n.get('已支付'), value: 'PAID' }
            ]));
        case '付款计划支付状态':
            return __assign({ render: function (value, record) {
                    var styles = renderStatusStyle(value);
                    return (React.createElement("div", { className: "option-line" },
                        React.createElement("span", { style: styles }),
                        value ? i18n.get(value) : '-'));
                } }, renderEveryStatus([
                { label: i18n.get('未支付'), value: i18n.get('未支付') },
                { label: i18n.get('部分支付'), value: i18n.get('部分支付') },
                { label: i18n.get('全部支付'), value: i18n.get('全部支付') },
                { label: i18n.get('超额支付'), value: i18n.get('超额支付') }
            ]));
        case '付款状态':
            return __assign({ render: function (value, record) {
                    var styles = renderStatusStyle(value);
                    return (React.createElement("div", { className: "option-line" },
                        React.createElement("span", { style: styles }),
                        value ? i18n.get(value) : '-'));
                } }, renderEveryStatus([
                { label: i18n.get('未付款'), value: i18n.get('未付款') },
                { label: i18n.get('已付款'), value: i18n.get('已付款') },
                { label: i18n.get('部分付款'), value: i18n.get('部分付款') },
                { label: i18n.get('超额付款'), value: i18n.get('超额付款') }
            ]));
        case '是否管理员修改':
            return {
                render: function (value) {
                    return (React.createElement("span", null, value === '1' ? '是' : '-'));
                },
            };
        default:
            return {
                filterType: 'text',
                render: function (value, line) {
                    if (value && Array.isArray(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                        var displayValue = value === null || value === void 0 ? void 0 : value.map(function (item) {
                            if (typeof item === 'object' && item !== null) {
                                return item.fileName || item.name || item.label || '-';
                            }
                            return String(item);
                        }).filter(function (item) { return item !== '-'; }).join(', ');
                        if (displayValue) {
                            return (React.createElement(Tooltip, { placement: "topLeft", title: displayValue },
                                React.createElement("span", { className: "data-link-table-text-style-new", style: renderDataLinkTableTextStyleNew('3', useNewStyle) }, displayValue)));
                        }
                        return React.createElement(NullCell, null);
                    }
                    if (value && typeof value === 'object') {
                        var displayValue = value.name || value.label;
                        if (displayValue) {
                            return (React.createElement(Tooltip, { placement: "topLeft", title: displayValue },
                                React.createElement("span", { className: "data-link-table-text-style-new", style: renderDataLinkTableTextStyleNew('3', useNewStyle) }, displayValue)));
                        }
                        return React.createElement(NullCell, null);
                    }
                    var data = value ? value : '-';
                    if (window.IS_SMG && data && data.indexOf('NCC:') === 0) {
                        var url_1 = getSMGNCCTextURL(value);
                        return React.createElement("a", { onClick: function () { return api.emit('@vendor:open:link', url_1); } }, "\u67E5\u770B\u5408\u540C");
                    }
                    var dom = renderRedirectCode(name, line, value);
                    if (dom) {
                        return dom;
                    }
                    var _a = formatLinkText(value, name), textValue = _a.textValue, domValue = _a.domValue;
                    var textValueStyle = renderDataLinkTableTextStyleNew('3', useNewStyle);
                    if ((entityInfo === null || entityInfo === void 0 ? void 0 : entityInfo.type) === 'CORPORATEBANKING_CONTRAT') {
                        var dataLink = get(line, 'dataLink', {});
                        var dataObj = fixEntityObj(dataLink);
                        var contractState = get(dataObj, 'contractState', {});
                        if ((contractState === null || contractState === void 0 ? void 0 : contractState.id) === 'COR_CONTRACT_REJECTED') {
                            return (React.createElement("span", { className: "data-link-table-text-style-new", style: textValueStyle },
                                textValue,
                                React.createElement("span", { style: { color: 'var(--eui-function-danger-500)' } },
                                    "[", contractState === null || contractState === void 0 ? void 0 :
                                    contractState.name,
                                    "]")));
                        }
                    }
                    if (value) {
                        return (React.createElement(Tooltip, { placement: "topLeft", title: textValue },
                            React.createElement("span", { className: "data-link-table-text-style-new", style: textValueStyle }, domValue)));
                    }
                    else {
                        return (React.createElement("span", { className: "data-link-table-text-style-new", style: textValueStyle }, textValue));
                    }
                }
            };
    }
}
function fixCurrency(propertyName) {
    var _a;
    var list = (_a = api.getState()['@common'].getCurrencyAll) === null || _a === void 0 ? void 0 : _a.slice();
    return {
        filterType: 'list',
        filterDataSource: [],
        lookup: {
            dataSource: [],
            displayExpr: 'label',
            valueExpr: 'value'
        },
        render: function (value) {
            var name = list === null || list === void 0 ? void 0 : list.find(function (i) { return value == (i === null || i === void 0 ? void 0 : i.numCode) || (value === null || value === void 0 ? void 0 : value.id) === (i === null || i === void 0 ? void 0 : i.numCode) || (value === null || value === void 0 ? void 0 : value.numCode) === (i === null || i === void 0 ? void 0 : i.numCode); });
            if (name) {
                var text = (name === null || name === void 0 ? void 0 : name.name) + " (" + (name === null || name === void 0 ? void 0 : name.strCode) + ")";
                return (React.createElement(Tooltip, { placement: "topLeft", title: text },
                    React.createElement("span", null, text)));
            }
            else {
                return React.createElement(NullCell, null);
            }
        }
    };
}
export function fixCurrencyList(value) {
    var _a;
    var list = (_a = api.getState()['@common'].getCurrencyAll) === null || _a === void 0 ? void 0 : _a.slice();
    var name = list === null || list === void 0 ? void 0 : list.find(function (i) { return value == (i === null || i === void 0 ? void 0 : i.numCode) || (value === null || value === void 0 ? void 0 : value.id) === (i === null || i === void 0 ? void 0 : i.numCode) || (value === null || value === void 0 ? void 0 : value.numCode) === (i === null || i === void 0 ? void 0 : i.numCode); });
    if (name) {
        return (name === null || name === void 0 ? void 0 : name.name) + " (" + (name === null || name === void 0 ? void 0 : name.strCode) + ")";
    }
    else {
        return '-';
    }
}
function fixDuration() {
    return {
        filterType: undefined,
        render: function (duration) {
            var m = Math.ceil((duration % 3600000) / 60000);
            var h = Math.floor(duration / 3600000);
            if (h > 0) {
                return React.createElement("div", null, i18n.get("{__k0}\u65F6{__k1}\u5206", { __k0: h, __k1: m }));
            }
            return React.createElement("div", null, i18n.get("{__k0}\u5206", { __k0: m }));
        }
    };
}
function fixDataLinkCount(property, bus, isSingleSelect, useCountCanLink) {
    if (useCountCanLink === void 0) { useCountCanLink = true; }
    return {
        filterType: undefined,
        render: function (obj, line) {
            if (typeof line.dataLink.totalCount !== 'number') {
                return React.createElement(NullCell, null);
            }
            return isSingleSelect || !useCountCanLink ? (React.createElement("div", { className: "option-line" },
                React.createElement("span", { className: "ml-5" }, line.dataLink.useCount + " / " + line.dataLink.totalCount))) : (React.createElement("div", { className: "option-line" },
                React.createElement("a", { className: "ant-dropdown-link mr-5", onClick: function (e) { return bus.emit('table:row:useCount:click', line); } }, line.dataLink.useCount),
                React.createElement("span", null, '/'),
                React.createElement("span", { className: "ml-5" }, line.dataLink.totalCount)));
        }
    };
}
export function generateList(obj) {
    var arr = [];
    var staffList = [];
    var roleList = [];
    var departmentList = [];
    staffList = obj ? obj.staff : [];
    roleList = obj ? obj.role : [];
    departmentList = obj ? obj.department : [];
    staffList.forEach(function (item) { return (item.type = 'staff'); });
    roleList.forEach(function (item) { return (item.type = 'role'); });
    departmentList.forEach(function (item) { return (item.type = 'department'); });
    arr = __spread(staffList, roleList, departmentList);
    return arr;
}
function fixStaffName() {
    return {
        filterType: 'ref',
        render: function (obj) {
            if (obj) {
                var name = getStaffShowByConfig(obj);
                return (React.createElement(Tooltip, { placement: "topLeft", title: name },
                    React.createElement("span", null, name)));
            }
            return React.createElement(NullCell, null);
        }
    };
}
function fixStaff(type, bus, property, platformType) {
    var _a = property.isHiddenEditBtn, isHiddenEditBtn = _a === void 0 ? false : _a, isManage = property.isManage;
    return {
        filterType: type === "staffFZ" ? "custom" : undefined,
        filterStyles: {
            wrapperStyle: {
                border: 'none',
                backgroundColor: 'transparent'
            },
            bodyStyle: {
                padding: '0'
            }
        },
        hiddenFilterAction: true,
        renderFilter: function (props) { return React.createElement(StaffFilter, __assign({}, props)); },
        render: function (obj, line) {
            var dataLink = line.dataLink;
            var ownerId = dataLink.ownerId;
            var staffList = [];
            var flag = false;
            var str = '';
            if (type === 'staffCYR') {
                staffList = generateList(obj);
                var CYRStr = !staffList.length ? '-' : obj;
                str = obj
                    ? obj.fullVisible && platformType != 'supplierFile' && platformType != 'SUPPLIER'
                        ? i18n.get('全部人员')
                        : CYRStr
                    : CYRStr;
                flag = obj ? obj.fullVisible || !staffList.length : !staffList.length;
            }
            else {
                staffList = obj ? [obj] : [];
                var active = obj && obj.active;
                flag = !active;
                str = active ? '' : '-';
            }
            var isShowEdit = obj && !obj.fullVisible;
            var fieldVisibility = ownerId !== undefined;
            if (!fieldVisibility || isHiddenEditBtn) {
                isShowEdit = false;
            }
            if (platformType === 'supplierFile') {
                isShowEdit = true;
            }
            if (type === 'staffFZ' && !isShowEdit && !(staffList === null || staffList === void 0 ? void 0 : staffList.length) && !isHiddenEditBtn) {
                isShowEdit = true;
            }
            var strAll = i18n.get('全部参与人');
            var domStr = i18n.get('查看所有');
            var _a = api.getState()['@common'].userinfo.staff, staff = _a === void 0 ? {} : _a;
            isShowEdit = (ownerId === null || ownerId === void 0 ? void 0 : ownerId.id) === (staff === null || staff === void 0 ? void 0 : staff.id);
            if (type === 'staffCYR' && (obj === null || obj === void 0 ? void 0 : obj.fullVisible)) {
                isShowEdit = false;
            }
            if (isManage && !(obj === null || obj === void 0 ? void 0 : obj.fullVisible)) {
                isShowEdit = true;
            }
            if (window.__PLANTFORM__ === 'MC' && isHiddenEditBtn) {
                isShowEdit = false;
            }
            return (React.createElement("div", { className: "option-line" },
                isShowEdit && !(bus === null || bus === void 0 ? void 0 : bus.isBatchEdit) && (bus === null || bus === void 0 ? void 0 : bus.has('table:row:edit:staff')) && (React.createElement("div", { style: {
                        color: 'var(--brand-base)',
                        fontSize: 14,
                        flexShrink: 0,
                        marginRight: 8,
                        cursor: 'pointer'
                    }, onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        bus === null || bus === void 0 ? void 0 : bus.emit('table:row:edit:staff', { type: type, obj: obj, line: line, property: property });
                    } }, i18n.get('编辑'))),
                React.createElement("div", null, flag ? (React.createElement("div", null, str)) : (React.createElement(PersonnelList, { dataSource: staffList, moreLine: false, popUpTitle: strAll, domStr: domStr })))));
        }
    };
}
function fixNumber(property) {
    var _a = property.unit, unit = _a === void 0 ? '' : _a, source = property.source, _b = property.name, name = _b === void 0 ? '' : _b;
    var canFilter = source !== 'planned';
    return {
        filterType: canFilter ? 'number' : undefined,
        sorter: canFilter,
        render: function (value, line) {
            if (!value && value !== 0) {
                return React.createElement(NullCell, null);
            }
            var planned = line.planned;
            var plannedValue = get(planned, property.name);
            var cls;
            if (plannedValue) {
                cls = fnShouldShowWarning(value, plannedValue) ? 'data_link_number_red_color' : 'datalink_item_value_color_nor';
            }
            else {
                cls = getNumberColor(name, value);
            }
            return React.createElement("span", { className: cls }, "" + value + unit);
        }
    };
}
function NullCell() {
    return React.createElement("span", null, "-");
}
function fixDocumentNo(label) {
    return {
        title: (React.createElement("span", null,
            label,
            React.createElement(Tooltip, { title: i18n.get('当前仅支持招商银行、建设银行的流水信息匹配单号。如有特殊需要，请联系易快报工作人员') },
                React.createElement(Icon, { style: { fontSize: '14px', color: '#e39a47' }, type: "question-circle-o" }))))
    };
}
export function getActionText(disableStrategy, line) {
    var title = '';
    var text = '';
    switch (disableStrategy) {
        case 'MANUAL_ADMIN':
        case 'MANUAL':
            text = line.dataLink.active === undefined ? '-' : line.dataLink.active ? i18n.get('停用') : i18n.get('启用');
            title = i18n.get('状态');
            break;
        case 'LIMIT_COUNT':
            text = line.dataLink.totalCount === undefined ? '-' : i18n.get('修改次数上限');
            title = i18n.get('引用次数');
            break;
        case 'WRITTEN_OFF':
            text = i18n.get('核销');
            break;
    }
    return { title: title, text: text };
}
export function getSMGNCCTextURL(data) {
    var _a, _b;
    var code = (_b = (_a = api.getState('@common').userinfo) === null || _a === void 0 ? void 0 : _a.staff) === null || _b === void 0 ? void 0 : _b.code;
    var url = data.split('NCC:')[1];
    return url.replace('%empcode%', code);
}
